import {Injectable} from '@angular/core';
import {environment} from '@env/environment';
import {AppConstant} from '@app/shared/constants';
import {HttpClient} from '@angular/common/http';
import { APIResponse } from '../core/ICore.interface';

@Injectable({
  providedIn: 'root'
})
export class BraintreeService {

  constructor(private http: HttpClient) {
  }

  submitNonce(nonceData: {
    userid: string, nonce: string, paypalEmail: string, paypalFirstName: string, paypalLastName: string
  }) {   
    return this.http.post(environment.baseUrl + AppConstant.SubmitTokenNonce, nonceData);
  }

  submitNoncePayment(nonceData: {
    userid: string, nonce: string, amount: string,email:string
  }) {
    return this.http.post(environment.baseUrl + AppConstant.SUBMIT_BRAINTREE_PAYMENT, nonceData);
  }

  GetPaymentToken() {
    return this.http.get<APIResponse<string>>(environment.baseUrl + AppConstant.GET_PAYMENT_TOKEN);
  }
}
